import { routerMiddleware } from "connected-react-router";
import { createBrowserHistory } from "history";
import { applyMiddleware, compose, createStore } from "redux";
import thunk from "redux-thunk";
import asyncDispatch from "./middleware/asyncDispatch";
import wsMiddleware, { wsConnect } from "./middleware/middleware";
import reducers from "./reducers";
import APIS from "./service/api";

import {
	accountManagementApi,
	authManagementApi,
	documentManagementApi,
	sumsubApi,
	tenantApi,
	thirdPartyIntegrationApi,
} from "@api";

//History
export const history = createBrowserHistory();

//Middlewares
const middlewares = [
	thunk,
	routerMiddleware(history),
	wsMiddleware,
	asyncDispatch,
	accountManagementApi.middleware,
	authManagementApi.middleware,
	documentManagementApi.middleware,
	tenantApi.middleware,
	thirdPartyIntegrationApi.middleware,
	accountManagementApi.middleware,
	sumsubApi.middleware,
];

//Redux Logging
if (process.env.NODE_ENV === "development") {
	const { logger } = require("redux-logger");
	middlewares.push(logger);
}
//chrome ext
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

/**
 * Creates redux store
 * @param {Object} preloadedState
 */
export default function configureStore(preloadedState) {
	const store = createStore(
		reducers(history, {
			[accountManagementApi.reducerPath]: accountManagementApi.reducer,
			[authManagementApi.reducerPath]: authManagementApi.reducer,
			[documentManagementApi.reducerPath]: documentManagementApi.reducer,
			[tenantApi.reducerPath]: tenantApi.reducer,
			[thirdPartyIntegrationApi.reducerPath]: thirdPartyIntegrationApi.reducer,
			[accountManagementApi.reducerPath]: accountManagementApi.reducer,
			[sumsubApi.reducerPath]: sumsubApi.reducer,
		}),
		preloadedState,
		composeEnhancers(applyMiddleware(...middlewares))
	);
	store.dispatch(
		wsConnect(
			`wss://${
				window.location.host.indexOf("localhost") > -1 ? APIS["base"] : window.location.host
			}${APIS["user-socket-api"]}`
		)
	);
	return store;
}
